import { lazyMarkdownEditor } from './lazyEditorFactory';

export const MarkdownEditor = lazyMarkdownEditor(() => import('./MarkdownEditor'));
